import BreadcrumbView from "../common/breadcrumb/breadcrumb.html";
import PassbooksListView from "./passbooks-list.html";
import PassbooksEditView from "./passbooks-edit.html";


angular.module("passbooks", [])

    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('passbooks', {
                url: "/passbooks",
                abstract: true,
                controller: "BreadcrumbCtrl",
                template: BreadcrumbView,
            })
            .state('passbooks.list', {
                url: "/list",
                controller: "PassbooksListCtrl",
                template: PassbooksListView,              
                // requiredPermission: ["NOTIFICATIONS_READ"]
            })
            .state('passbooks.edit', {
                url: "/edit/:id",
                controller: "PassbookEditCtrl",
                template: PassbooksEditView,
                // requiredPermission: ["NOTIFICATIONS_READ"]
            });
    }]);